import React from 'react';
import { PayPal } from '../payment-methods/PayPal';
import s from './styles.scss';

export const PayPalElems = (props: { fundingSources: string[] }) => {
  return (
    <>
      {props.fundingSources.map((fs) => (
        <PayPalElem key={fs} fundingSource={fs} mainSource={false}></PayPalElem>
      ))}
    </>
  );
};

export const PayPalElem = (props: { fundingSource: string; mainSource: boolean }) => {
  return (
    <div className={s.layoutItem}>
      <PayPal fundingSource={props.fundingSource} mainSource={props.mainSource} />
    </div>
  );
};

/**
 * Secondary Payment Options Wrapper
 */
export const SecondaryPoWrapper = (props) => {
  return <div className={s.restSources}>{props.children}</div>;
};
